import React, { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { Modal } from 'antd';
import { reset } from 'app/entities/checkIn/checkIn-draft.reducer';
import { getBoxWorkStatus } from 'app/entities/common/common.reducer';
import { KrTypes } from 'app/shared/model/enum/kr.enum';
import ReportQualitativeResult from './reportQualitativeResult';
import ReportQuantitativeResult from './reportQuantitativeResult';
import { getListKrCheckInDraft } from 'app/entities/checkIn/checkIn-draft.reducer';
import * as _ from 'lodash';
type IReportQualitativeResult = {
  isOpen: boolean;
  onClose: (isReload?: boolean) => void;
  krSelected?: any;
};

export const ReportKr = ({ isOpen, onClose, krSelected }: IReportQualitativeResult) => {
  const dispatch = useAppDispatch();
  const filters = useAppSelector(state => state.filters.orgCheckIn);
  const entities = useAppSelector(state => state.checkInDraft.entities);
  const [krCheckIns, setKrCheckIns] = useState([])
  const [krInfo, setKrInfo] = useState(null)
  const [demKr, setDemKr] = useState(null)
  const [isUpdateSuccess, setUpdateSuccess] = useState(false);

  const handleClose = (isReload = undefined) => {
    dispatch(reset());
    onClose(isReload ?? isUpdateSuccess);
  };

  useEffect(() => {
    dispatch(getBoxWorkStatus({ statusType: 1 }));
    if (krSelected?.id) {
      handleGetListKrCheckInDraft();
    }

  }, [filters, krSelected]);

  useEffect(() => {
    if (entities && entities.length > 0) {
      setKrCheckIns(entities);
      const index = _.findIndex(entities, (e: any) => {
        return e.nextCheckinId === krSelected?.id;
      }, 0);
      setDemKr(index);
    }
  }, [entities])

  useEffect(() => {
    if (krCheckIns && krCheckIns.length > 0 && demKr !== null && demKr >= 0) {
      if (krCheckIns[demKr])
        setKrInfo({ id: krCheckIns[demKr].nextCheckinId, krType: krCheckIns[demKr].krType });
      else
        setKrInfo({ id: krCheckIns[0].nextCheckinId, krType: krCheckIns[0].krType });
    }
  }, [demKr, krCheckIns])

  const handleGetListKrCheckInDraft = () => {
    dispatch(getListKrCheckInDraft(krSelected?.id))
  }

  const handleNextKrCheckIn = () => {
    setDemKr((previous) => previous + 1);
  }

  return (
    <Modal
      width={1300}
      open={isOpen}
      maskClosable={false}
      footer={null}
      onCancel={() => {
        handleClose();
      }}
    >
      {krInfo?.krType === KrTypes.Qualitative ? (
        <ReportQualitativeResult krCheckIn={krInfo} setUpdateSuccess={setUpdateSuccess} handleNextData={handleNextKrCheckIn} handleClose={handleClose} />
      ) : (
        <ReportQuantitativeResult krCheckIn={krInfo} setUpdateSuccess={setUpdateSuccess} handleNextData={handleNextKrCheckIn} handleClose={handleClose} />
      )}
    </Modal>
  );
};

export default ReportKr;
